var _path, _path2, _path3, _path4, _rect, _g, _circle, _circle2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "credit-card",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.446,
    height: 27.039,
    viewBox: "0 0 33.446 27.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8602",
    "data-name": "Path 8602",
    d: "M51.751,68.511l1.961-12.519a2.331,2.331,0,0,0-1.931-2.67h0L25.324,49.075a2.33,2.33,0,0,0-2.67,1.931l-.94,5.855V68.438Z",
    transform: "translate(-20.296 -49.045)",
    fill: "#c3c3c3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8603",
    "data-name": "Path 8603",
    d: "M96,97.255l-7.514-1.206c-5.047,7.722-13.206,13.071-19.462,16.33l26.947.065,1.961-12.519A2.331,2.331,0,0,0,96,97.255Z",
    transform: "translate(-64.51 -92.978)",
    fill: "#c3c3c3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8604",
    "data-name": "Path 8604",
    d: "M2.33,159.771h26.8a2.33,2.33,0,0,1,2.33,2.33v15.145a2.33,2.33,0,0,1-2.33,2.33H2.33A2.33,2.33,0,0,1,0,177.246V162.1A2.33,2.33,0,0,1,2.33,159.771Z",
    transform: "translate(0 -152.538)",
    fill: "#4398d1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8605",
    "data-name": "Path 8605",
    d: "M123.749,159.771h-.466c-5.5,9.762-15.774,16.459-22.046,19.805h22.512a2.33,2.33,0,0,0,2.33-2.33V162.1A2.33,2.33,0,0,0,123.749,159.771Z",
    transform: "translate(-94.624 -152.538)",
    fill: "#3e8cc7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1373",
    "data-name": "Rectangle 1373",
    width: 5.825,
    height: 4.66,
    transform: "translate(2.913 10.146)",
    fill: "#c3e2e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5074",
    "data-name": "Group 5074",
    transform: "translate(2.913 11.893)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1374",
    "data-name": "Rectangle 1374",
    width: 1.748,
    height: 1.165,
    transform: "translate(0 0)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1375",
    "data-name": "Rectangle 1375",
    width: 1.748,
    height: 1.165,
    transform: "translate(4.078 0)",
    fill: "#87ced9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 2.913,
    cy: 2.913,
    r: 2.913,
    transform: "translate(22.718 18.301)",
    fill: "#87ced9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    cx: 2.913,
    cy: 2.913,
    r: 2.913,
    transform: "translate(19.223 18.301)",
    fill: "#c3e2e6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5075",
    "data-name": "Group 5075",
    transform: "translate(2.33 10.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1376",
    "data-name": "Rectangle 1376",
    width: 3.495,
    height: 1.165,
    transform: "translate(0 8.738)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1377",
    "data-name": "Rectangle 1377",
    width: 3.495,
    height: 1.165,
    transform: "translate(5.825 8.738)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1378",
    "data-name": "Rectangle 1378",
    width: 3.495,
    height: 1.165,
    transform: "translate(11.65 8.738)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1379",
    "data-name": "Rectangle 1379",
    width: 15.145,
    height: 1.165,
    transform: "translate(0 12.233)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1380",
    "data-name": "Rectangle 1380",
    width: 1.165,
    height: 2.33,
    transform: "translate(18.058 0)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1381",
    "data-name": "Rectangle 1381",
    width: 1.165,
    height: 2.33,
    transform: "translate(20.388 0)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1382",
    "data-name": "Rectangle 1382",
    width: 1.165,
    height: 2.33,
    transform: "translate(22.718 0)",
    fill: "#87ced9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1383",
    "data-name": "Rectangle 1383",
    width: 1.165,
    height: 2.33,
    transform: "translate(25.048 0)",
    fill: "#87ced9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCard);
export default __webpack_public_path__ + "static/media/icon-credit-card.ac99af0a.svg";
export { ForwardRef as ReactComponent };